import { NgModule } from '@angular/core';
import { SummaryGroupToTranslationPipe } from './pipes/summary-group-to-translation.pipe';
import { ToCustomItfgAmountPipe } from './pipes/to-custom-itfg-amount.pipe';
import { DisplayNationalityListPipe } from './pipes/display-nationality-list.pipe';
import {NssiContractReasonPipe} from '@app/main/identity-reports/pipes/nssi-contract-reason.pipe';
import {ReportCacheRegisterPipe} from '@app/main/identity-reports/pipes/report-cache-register.pipe';
import {VerificationStatusReasonToTranslationKeyPipe} from '@app/main/identity-reports/pipes/verification-status-reason-to-translation-key.pipe';

@NgModule({
  declarations: [
    SummaryGroupToTranslationPipe,
    ToCustomItfgAmountPipe,
    DisplayNationalityListPipe,
    NssiContractReasonPipe,
    ReportCacheRegisterPipe,
    VerificationStatusReasonToTranslationKeyPipe
  ],
  exports: [
    SummaryGroupToTranslationPipe,
    ToCustomItfgAmountPipe,
    DisplayNationalityListPipe,
    NssiContractReasonPipe,
    ReportCacheRegisterPipe,
    VerificationStatusReasonToTranslationKeyPipe
  ],
  imports: [],
  providers: [VerificationStatusReasonToTranslationKeyPipe]
})
export class IdentityReportsPipesModule {}
